export default class IndicationHelper {
  static addBlinkingClass = (
    elementId: string,
    { className = 'blinking', duration = 2000 } = {}
  ) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.classList.add(className);
      setTimeout(() => {
        element.classList.remove(className);
      }, duration);
    }
  };
}
